import { getOrderSelectLabel } from '../utils/tiktokOrderDisplay'

const OrderSelect = ({ ordersList, currentOrderID, handleOrderChange,handleMinWidthChange, mobHide, isTiktok }) => {
    return (
      <div className="d-flex align-items-center">
          {ordersList.length && (
              <div 
                  className="select-box select-dropdown-box"
                  style={{ 
                      width: '100%', 
                  }}
              >
                  <span 
                      className="select-icon" 
                      style={{zIndex: '9'}}
                  >
                      <i className="fa fa-caret-down"></i>
                  </span>
                  <select
                        onChange={(e) => {
                            if (handleMinWidthChange) handleMinWidthChange(e);  // Call the new handler
                            if (handleOrderChange) handleOrderChange(e);        // Call the original handler
                        }}
                        value={currentOrderID}
                        tw="h-full w-full"
                        className="select-dropdown"
                  >
                      {ordersList.map((orderItem) => {
                        const displayId = getOrderSelectLabel(orderItem)
                        return (
                      <option key={orderItem.id} value={orderItem.source_id}>
                          {isTiktok ? `#${displayId}` : `Order #${displayId}`}
                      </option>
                        )
                      })}
                  </select>
              </div>
          )}
      </div>
    );
  };
  
  export default OrderSelect;
  